import { render, staticRenderFns } from "./TrainingPlanItemNotes.vue?vue&type=template&id=c5e2caa6&scoped=true&"
import script from "./TrainingPlanItemNotes.vue?vue&type=script&lang=ts&"
export * from "./TrainingPlanItemNotes.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingPlanItemNotes.vue?vue&type=style&index=0&id=c5e2caa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e2caa6",
  null
  
)

export default component.exports